import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { KeyRound, LogOut } from "lucide-react";
import MuteToggle from "@/components/MuteToggle";

/** Top bar shared by Admin / Teacher / Student dashboards. */
export default function DashboardHeader({ subtitle }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="border-b border-stone-200 bg-white" data-testid="dashboard-header">
      <div className="mx-auto max-w-6xl px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-md bg-amber-500 text-stone-900 flex items-center justify-center">
            <KeyRound className="h-5 w-5" />
          </div>
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-tight">KKS</div>
            <div className="text-xs text-stone-500" data-testid="header-subtitle">
              {subtitle}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <MuteToggle />
          <div className="text-sm text-stone-700 hidden sm:block" data-testid="header-user">
            {user?.name}{" "}
            <span className="text-stone-400">·</span>{" "}
            <span className="capitalize text-stone-500">{user?.role}</span>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              signOut();
              navigate("/login", { replace: true });
            }}
            data-testid="dashboard-signout-button"
          >
            <LogOut className="mr-2 h-4 w-4" /> Sign out
          </Button>
        </div>
      </div>
    </header>
  );
}
